'use client';

import '@ui5/webcomponents/dist/TextArea.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `TextArea` component is used to enter multiple lines of text.
 *
 * When empty, it can hold a placeholder similar to a `Input`. You can define the rows of the `TextArea` and also determine specific behavior when handling long texts.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-TextArea)
 */
const TextArea = withWebComponent('ui5-textarea', ['accessibleName', 'accessibleNameRef', 'growingMaxLines', 'maxlength', 'name', 'placeholder', 'rows', 'value', 'valueState'], ['disabled', 'growing', 'readonly', 'required', 'showExceededText'], ['valueStateMessage'], ['change', 'input']);
TextArea.displayName = 'TextArea';
TextArea.defaultProps = {
  growingMaxLines: 0,
  maxlength: null,
  rows: 0,
  valueState: ValueState.None
};
export { TextArea };